<div class="landing">
  <div class="text-center bg_image p-0">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col">
          <div class="card logo-card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <img src="assets\img\background\NBR_logo.jpg" class="nbr_logo">
                </div>
                <div class="col-6">
                  <a href="#" [routerLink]="['/landing-page']"><img src="assets\img\logo\eReturn_logo_png.png"
                      class="ereturn-logo " alt="logo">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <!-- <div class="col-md-4 d-flex">
          <a href="https://secure.incometax.gov.bd/TINHome" target="_blank">
            <div class="card landing-cards">
              <h1>eTIN</h1>
              <span class="sub-text" style="color: gray;">Register as a taxpayer</span>
            </div>
          </a>
        </div> -->
        <div class="col-md-4 d-flex">
          <a href="https://secure.incometax.gov.bd/TINHome" target="_blank" class="d-flex w-100 text-decoration-none">
            <div class="card landing-cards w-100">
              <h1>eTIN</h1>
              <span class="sub-text" style="color: gray;">Register as a taxpayer</span>
            </div>
          </a>
        </div>
        <div class="col-md-4 d-flex">
          <a href="#" class="d-flex w-100 text-decoration-none"
            (click)="onClickEReturn($event, promptForEReturn)">
            <div class="card landing-cards w-100">
              <h1>eReturn</h1>
              <span class="sub-text" style="color: gray;">File your tax return</span>
              <div style="color: gray; font-size: 14px; font-style: italic;">Download Express Certificate</div>
            </div>
          </a>
        </div>  
        <div class="col-md-4 d-flex">
          <a href="#" [routerLink]="['/submission-verification']" class="d-flex w-100 text-decoration-none">
            <div class="card landing-cards w-100">
              <h1>ReturnVerify/PSR</h1>
              <span class="sub-text" style="color: gray;">Verify your Return</span>
            </div>
          </a>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4 d-flex">
          <a href="https://trms.nbr.gov.bd/" target="_blank" class="d-flex w-100 text-decoration-none" style="color: #24682D;">
            <div class="card landing-cards w-100">
              <h1>TRMS</h1>
              <span class="sub-text" style="color: gray;">Tax Representative Management System</span>
            </div>
          </a>
        </div>
        <div class="col-md-4 d-flex">
          <a href="https://etds.gov.bd/login" target="_blank" class="d-flex w-100 text-decoration-none" style="color: #24682D;">
            <div class="card landing-cards w-100">
              <h1>eTaxPayment(eTDS)</h1>
              <span class="sub-text" style="color: gray;">Manage your source tax</span>
            </div>
          </a>
        </div>
        <div class="col-md-4 d-flex">
          <!-- <a [routerLink]="['/e-tax-service-content']" class=""> -->
          <a href="https://ticket.etaxnbr.gov.bd/" target="_blank" class="d-flex w-100 text-decoration-none">
            <div class="card landing-cards w-100">
              <h1>eTaxService</h1>
              <span class="sub-text" style="color: gray;">Interact online with tax support team</span>
            </div>
          </a>
        </div>
      </div>

    </div>
  </div>

</div>

<ng-template #promptForEReturn>
  <div class="modal-body p-5 text-center" style="border-radius: 15px; background-color: #f9f9f9; position: relative;">

    <button type="button" class="close" aria-label="Close"
            style="position: absolute; top: 15px; right: 20px; background: none; border: none; outline:none; font-size: 1.5rem;">
      <span aria-hidden="true" (click)="modalRef.hide()">&times;</span>
    </button>

    <div class="mt-3">
      <h5 class="mb-3">Are you registered in <strong>eReturn</strong> System?</h5>
      <p class="text-muted">Please select an option below to proceed:</p>
    </div>

    <div class="mt-4 d-flex justify-content-center">
      <button class="btn btn-outline-success mx-2" (click)="navigateToEReturnSignIn()"
              style="width: 200px; border-radius: 30px;">I am already registered
      </button>
      <button class="btn btn-outline-danger mx-2" (click)="navigateToEReturnSignUp()"
              style="width: 200px; border-radius: 30px;">I am not yet registered
      </button>
    </div>
  </div>
</ng-template>

<ng-template #maintenanceModal>
  <div class="maintenance-modal">
    <button type="button" class="maintenance-modal__close" aria-label="Close" (click)="closeMaintenanceModal()">
      <span aria-hidden="true">&times;</span>
    </button>

    <!-- <div class="maintenance-modal__header">
      <div class="maintenance-modal__icon-wrap">
        <i class="fa fa-wrench" aria-hidden="true"></i>
      </div>
      <h4 class="maintenance-modal__title">System Maintenance Notice</h4>
      <p class="maintenance-modal__subtitle">রক্ষণাবেক্ষণ সংক্রান্ত বিজ্ঞপ্তি</p>
    </div> -->

    <div class="maintenance-modal__body">
      <p>
        Please be informed that the return submission will remain unavailable on
        <strong>1 July</strong>, from <strong>12:00 AM to 12:30 AM</strong>.
      </p>

      <div class="maintenance-modal__divider"></div>
      
      <p>
        অনুগ্রহ করে অবগত থাকুন যে, <strong>১ জুলাই</strong> রাত <strong>১২:০০ টা</strong> থেকে
        <strong>১২:৩০ টা</strong> পর্যন্ত রিটার্ন জমাদান বন্ধ থাকবে।
      </p>
    </div>

    <!-- <div class="maintenance-modal__body">
      <div class="maintenance-modal__message maintenance-modal__message--en">
        <p>
          Please be informed that the return submission will remain unavailable on
          <strong>1 July</strong>, from <strong>12:00 AM to 12:30 AM</strong>.
        </p>
      </div>

      <div class="maintenance-modal__divider"></div>

      <div class="maintenance-modal__message maintenance-modal__message--bn">
        <p>
          অনুগ্রহ করে অবগত থাকুন যে, <strong>১ জুলাই</strong> রাত <strong>১২:০০ টা</strong> থেকে
          <strong>১২:৩০ টা</strong> পর্যন্ত রিটার্ন জমাদান বন্ধ থাকবে।
        </p>
      </div>
    </div> -->

    <!-- <div class="maintenance-modal__footer">
      <button type="button" class="maintenance-modal__btn" (click)="closeMaintenanceModal()">
        I Understand / আমি বুঝতে পেরেছি
      </button>
    </div> -->
  </div>
</ng-template>

<!--<ng-template #confirmPopup>-->
<!--  <div class="pdf-container">-->
<!--    <i class="fa fa-times-circle close-icon"-->
<!--       aria-hidden="true"-->
<!--       (click)="modalRefConfirm.hide()">-->
<!--    </i>-->

<!--    <pdf-viewer-->
<!--      [src]="gonovotePdfSrc"-->
<!--      [render-text]="true"-->
<!--      [zoom]="0.7">-->
<!--      style="display: block;">-->
<!--    </pdf-viewer>-->
<!--  </div>-->
<!--</ng-template>-->


<ngx-ui-loader></ngx-ui-loader>

